import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    "model-value": _ctx.snackBar,
    timeout: _ctx.snackBarTimeout,
    color: _ctx.snackBarColor,
    "onUpdate:modelValue": _ctx.updateSnackBarModelValue
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { innerHTML: _ctx.snackBarText }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["model-value", "timeout", "color", "onUpdate:modelValue"]))
}